<template>
  <b-modal :active="show" @close="toggle" class="modal" has-modal-card>
    <div class="modal-content">
      <div class="content is-medium">
        <embed :src="url" type="application/pdf" width="100%" height="98%">
      </div>
      <div class="columns">
        <div class="column">
          <button type="button" @click="toggle" class="button is-primary is-fullwidth">Close</button>
        </div>
        <div v-if="fileName" class="column is-one-quarter">
          <a href="" @click.prevent="download" class="button is-info is-fullwidth">
            <span class="icon">
              <font-awesome-icon icon="file-download" />
            </span>
            <span>Download</span>
          </a>
        </div>
      </div>
    </div>

  </b-modal>
</template>

<script>
import downloadBlob from '@/helpers/downloadBlob'
import dataURIToBlob from '@/helpers/dataUriToBlob'

export default {
  name: 'ModalDisplayPdf',

  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    fileName: {
      type: String
    },
    filePath: {
      type: String,
      required: true
    },
    isLink: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    url() {
      let blob = ''
      if (this.filePath && this.filePath.startsWith('data:')) {
        blob = window.URL.createObjectURL(dataURIToBlob(this.filePath))
      } else {
        blob = this.filePath
      }
      return blob
    }
  },

  methods: {
    download() {
      downloadBlob({ fileString: this.filePath, userFriendlyName: this.fileName, isLink: this.isLink })
    },

    toggle() {
      this.$emit('update:show', false)
    }
  }
}
</script>

<style scoped>
.modal {
  z-index: 999;
}

.modal-content {
  background-color: white;
  border-radius: 10px;
  padding: 15px;
  width: 900px;
  overflow: hidden;
}

.content {
  height: 80vh;
  max-height: 900px;
  overflow: hidden;
  border: 1px solid #eeeeee;
}
</style>
